import { getCookie, setCookie } from '@resources/js/helpers/cookies'

const COOKIE_NAME = 'backRedirectDone'
const COOKIE_VAL = '1'
const BACK_HASH = '#bkc'

const initBackBtn = ({ partnerUrl, beforeActionCallback }) => {
	if (getCookie(COOKIE_NAME) === COOKIE_VAL) return

	const clickTitle = document.title
	const clickHref = window.location.href
	const eventType = window.PointerEvent ? 'pointerup' : 'click'

	const updateSatate = () => {
		history.replaceState({}, '', BACK_HASH)
		history.pushState({}, clickTitle, clickHref)
	}

	document.addEventListener(eventType, updateSatate, { once: true })

	window.addEventListener('popstate', () => {
		if (
			getCookie(COOKIE_NAME) === COOKIE_VAL ||
			!window.location.href.includes(BACK_HASH)
		)
			return

		beforeActionCallback?.()

		setCookie(COOKIE_NAME, COOKIE_VAL)
		setCookie('clkndr', 1)

		location.href = partnerUrl
	})
}

export default initBackBtn
